import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./styled-components.module.css";

export const PageTitle = ({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) => (
	<h1 {...props} className={cx(styles.pageTitle, className)} />
);

export const Pane: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
	<div {...props} className={cx(styles.pane, className)} />
);

export const Link = ({ className, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
	<a {...props} className={cx(styles.link, className)} />
);

export const InlineLink = ({ className, ...props }: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
	<a {...props} className={cx(styles.inlineLink, className)} />
);
